import {FloatingReferenceTrigger, FloatingProvider, useFloating} from '~/components'
import {PopoutLayout} from '../popout_layout'

/**
 * Popout component
 * @param {('docs' | 'confirm' | 'delete' | 'legend')} [type] - Optional. Type of popout to display.
 */
export const Popout = ({
	ref,
	type,
	trigger,
	triggerEvent = 'click',
	placement,
	width = 250,
	maxHeight = 400,
	disabled,
	open,
	onOpenChange,
	...rest
}) => {
	const floating = useFloating({placement, maxHeight, open, onOpenChange})

	const config = {
		hover: {enabled: triggerEvent === 'hover'},
		disabled,
	}

	return (
		<FloatingProvider floating={floating} config={config}>
			<FloatingReferenceTrigger ref={ref} trigger={trigger} disabled={disabled} />
			<PopoutLayout type={type} width={width} {...rest} />
		</FloatingProvider>
	)
}
